import React from "react";
import copy from "copy-to-clipboard";
import {
  IHighlightCommon,
  PopoverOptionCopy,
} from "~/typings/annotate/annotation";
import { CopyIcon } from "~/components/icons";
import { useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export default function AnnotateCopy({
  highlight,
  config,
  closePopover,
}: {
  config: PopoverOptionCopy;
  highlight: IHighlightCommon;
  closePopover: () => void;
}) {
  const { t } = useLingui();
  document.addEventListener("keydown", function (event) {
    if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
      let text = window?.getSelection()?.toString();
      if (highlight) {
        text = highlight.text;
      }
      if (text) {
        copy(text);
      }
    }
  });

  const handlCopy = () => {
    if (config.copy) {
      closePopover();
      return config.copy();
    }
    let text = window?.getSelection()?.toString();
    if (highlight) {
      text = highlight.text;
    }
    copy(text || t(msg`Something didn't work as expected, sorry.`));
    closePopover();
  };
  return (
    <button
      onClick={handlCopy}
      className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1"
    >
      <CopyIcon className="h-5 w-5" />
    </button>
  );
}
